import React, { useEffect, useState } from "react";
import logo from "../../Assets/Images/BLU TAXI logo.png";
import { useTranslation } from "react-i18next";
import TranslateDropdown from "../Elements/TranslateDropdown";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import { paths } from "../../config/constants";
import { useDispatch, useSelector } from "react-redux";
import { reset } from "../../redux/reducers/login";
import { resetContact } from "../../redux/reducers/contactReducer";
import { resetHomeRe } from "../../redux/reducers/homeReducer";
import { toast } from "react-toastify";
import { clearSession } from "../Elements/Session";
import { FaUserCircle, FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { Popper, Paper, MenuList, Grow, ClickAwayListener, MenuItem } from "@mui/material";
import { logoutUser } from "../Elements/Session";

export default function Header() {
  const logingUser = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  // Services Dropdown
  const [servicesOpen, setServicesOpen] = useState(false);
  const [servicesAnchor, setServicesAnchor] = useState(null);

  // Help Dropdown
  const [helpOpen, setHelpOpen] = useState(false);
  const [helpAnchor, setHelpAnchor] = useState(null);

  // Register Dropdown
  const [registerOpen, setRegisterOpen] = useState(false);
  const [registerAnchor, setRegisterAnchor] = useState(null);

  // Handlers for toggle
  const toggle = () => setIsOpen(!isOpen);

  // Hover Handlers
  const handleServicesMouseEnter = (event) => {
    setServicesOpen(true);
    setServicesAnchor(event.currentTarget);
  };
  const handleServicesMouseLeave = () => setServicesOpen(false);

  const handleHelpMouseEnter = (event) => {
    setHelpOpen(true);
    setHelpAnchor(event.currentTarget);
  };
  const handleHelpMouseLeave = () => setHelpOpen(false);

  const handleRegisterMouseEnter = (event) => {
    setRegisterOpen(true);
    setRegisterAnchor(event.currentTarget);
  };
  const handleRegisterMouseLeave = () => setRegisterOpen(false);

  const handleClickAway = (setterOpen) => {
    setterOpen(false);
  };


const handleLogout = async () => {
  await logoutUser({
    dispatch,
    navigate,
  });
};

  const avenirNextStyle = {
    // fontFamily: "AvenirNext, sans-serif",
    fontFamily: "poppins-sans-serif",
    fontWeight: 600, // increase weight
  };

  return (
    <>
      <div className="d-flex flex-column-reverse flex-lg-column">
            {/* Top header (blue bar) */}
       <div
  className="top-header row gap-sm-4 ps-4 pe-2 align-items-center"
  style={{
    // backgroundColor: "#0E4672",
    backgroundColor: "#0b2d48",
    color: "white",
    minHeight: "40px",
  }}
>
  <div className="container text-white pe-0 ps-0">
    <div className="row align-items-center">

      {/* Phone number block */}
     <div
  className="col-6 col-md-2 text-nowrap m-0"
  style={{ paddingLeft: "24px" }}
>
        <a
          href="tel:xxx-xxx-xxx"
          style={{ textDecoration: "none", color: "white" }}
        >
          <span>
           <svg width="18" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M13 1.00001C13 0.734794 13.1053 0.48044 13.2929 0.292903C13.4804 0.105367 13.7348 1.00539e-05 14 1.00539e-05C16.6513 0.00292165 19.1931 1.05743 21.0678 2.93216C22.9426 4.80689 23.9971 7.34874 24 10C24 10.2652 23.8946 10.5196 23.7071 10.7071C23.5196 10.8947 23.2652 11 23 11C22.7348 11 22.4804 10.8947 22.2929 10.7071C22.1053 10.5196 22 10.2652 22 10C21.9976 7.87901 21.154 5.84556 19.6542 4.34579C18.1544 2.84601 16.121 2.00239 14 2.00001C13.7348 2.00001 13.4804 1.89465 13.2929 1.70712C13.1053 1.51958 13 1.26523 13 1.00001ZM14 6.00001C15.0609 6.00001 16.0783 6.42144 16.8284 7.17158C17.5786 7.92173 18 8.93915 18 10C18 10.2652 18.1053 10.5196 18.2929 10.7071C18.4804 10.8947 18.7348 11 19 11C19.2652 11 19.5196 10.8947 19.7071 10.7071C19.8946 10.5196 20 10.2652 20 10C19.9984 8.4092 19.3657 6.884 18.2409 5.75912C17.116 4.63425 15.5908 4.0016 14 4.00001C13.7348 4.00001 13.4804 4.10537 13.2929 4.2929C13.1053 4.48044 13 4.73479 13 5.00001C13 5.26523 13.1053 5.51958 13.2929 5.70712C13.4804 5.89465 13.7348 6.00001 14 6.00001ZM23.093 16.739C23.6725 17.3201 23.9979 18.1073 23.9979 18.928C23.9979 19.7487 23.6725 20.5359 23.093 21.117L22.183 22.166C13.993 30.007 -5.93701 10.082 1.78299 1.86601L2.93299 0.86601C3.51475 0.302687 4.29492 -0.00894087 5.10469 -0.0014551C5.91446 0.00603066 6.68873 0.332028 7.25999 0.90601C7.29099 0.93701 9.14399 3.34401 9.14399 3.34401C9.69382 3.92164 9.99989 4.68894 9.99859 5.48641C9.99728 6.28389 9.6887 7.05018 9.13699 7.62601L7.97899 9.08201C8.61983 10.6391 9.56205 12.0543 10.7515 13.2461C11.9409 14.438 13.3542 15.383 14.91 16.027L16.375 14.862C16.9509 14.3107 17.717 14.0025 18.5143 14.0014C19.3115 14.0003 20.0785 14.3063 20.656 14.856C20.656 14.856 23.062 16.708 23.093 16.739ZM21.717 18.193C21.717 18.193 19.324 16.352 19.293 16.321C19.087 16.1167 18.8086 16.0021 18.5185 16.0021C18.2284 16.0021 17.95 16.1167 17.744 16.321C17.717 16.349 15.7 17.956 15.7 17.956C15.5641 18.0642 15.4023 18.1351 15.2306 18.1618C15.059 18.1884 14.8833 18.1699 14.721 18.108C12.7054 17.3576 10.8747 16.1827 9.35282 14.6631C7.83092 13.1434 6.65339 11.3144 5.89999 9.30001C5.83318 9.13547 5.81141 8.9561 5.83689 8.78035C5.86237 8.6046 5.9342 8.43881 6.04499 8.30001C6.04499 8.30001 7.65199 6.28201 7.67899 6.25601C7.88325 6.05 7.99786 5.77163 7.99786 5.48151C7.99786 5.19139 7.88325 4.91302 7.67899 4.70701C7.64799 4.67701 5.80699 2.28201 5.80699 2.28201C5.59789 2.09452 5.32499 1.99411 5.04423 2.00136C4.76348 2.00861 4.49613 2.12297 4.29699 2.32101L3.14699 3.32101C-2.49501 10.105 14.776 26.418 20.721 20.8L21.632 19.75C21.8455 19.5523 21.9737 19.2793 21.9896 18.9887C22.0054 18.6982 21.9077 18.4128 21.717 18.193Z" fill="white" /></svg>
          </span>
          <span className="ms-2">xxx-xxx-xxx</span>
        </a>
      </div>

      {/* Address block */}
      <div className="col-4 col-md-2 d-flex align-items-center p-0 m-0">
        <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16" > <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" /> <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" /> </svg>
        </span>
        <span className="ms-2">xxx-xxx-xxx</span>
      </div>

      {/* Construction text */}
      {/* <div className="col-12 col-md-5 text-center d-none d-lg-block"> */}
      <div className="col-12 col-md-5 text-center" >
        <strong style={{fontSize: "15px" }}>This Website is Under Construction</strong>
      </div>

      {/* Social icons */}
      <div className="col-4 col-md-3 d-none d-lg-flex justify-content-end pe-2">
        <div style={{ display: "flex", gap: "12px" }}>
          <a
            href="#"
            style={{
              color: "#fff",
              width: "35px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            <FaFacebookF />
          </a>

          <a
            href="#"
            style={{
              color: "#fff",
              width: "35px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            <FaInstagram />
          </a>

          <a
            href="#"
            style={{
              color: "#fff",
              width: "35px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>

    </div>
  </div>
</div>
    
        {/* Navbar (will appear on top for mobile/tablet due to wrapper above) */}
        <header>
          <Navbar expand="lg" className="px-4 py-1 pe-2" style={{ backgroundColor: "#fff" }}>
            <NavbarBrand>
              <Link to={paths.home}>
                <img src={logo} width="150" height="55" alt="Logo" />
              </Link>
            </NavbarBrand>

            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="mx-auto align-items-center" navbar>
                <NavItem>
                  <NavLink>
                    <Link to={paths.home} className="nav-link text-dark" style={avenirNextStyle}>
                      {t("header-home") || "Calculate Price & Book"}
                    </Link>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink>
                    <Link to={paths.aboutUs} className="nav-link text-dark" style={avenirNextStyle}>
                      {t("header-aboutUs") || "About Us"}
                    </Link>
                  </NavLink>
                </NavItem>


                {/* Services Dropdown */}
                <NavItem
                  onMouseEnter={handleServicesMouseEnter}
                  onMouseLeave={handleServicesMouseLeave}
                  style={{ position: "relative" }}
                >
                  <NavLink style={{ cursor: "pointer", color: "#000", ...avenirNextStyle }} onClick={() => navigate(paths.services)}>
                  {t("header-ourservices") || "Our Services"}
                    <KeyboardArrowDownIcon
                      fontSize="small"
                      style={{
                        marginLeft: "4px",
                        transition: "0.3s",
                        transform: servicesOpen ? "rotate(180deg)" : "rotate(0deg)",
                        color: "#000",
                      }}
                    />
                  </NavLink>
                  {/* <Popper open={servicesOpen} anchorEl={servicesAnchor} placement="bottom-start" transition disablePortal > */}
                  <Popper
                    open={servicesOpen}
                    anchorEl={servicesAnchor}
                    placement="bottom-start"
                    transition
                    sx={{
                      zIndex: 9999,
                    }}
                  >
                    {({ TransitionProps }) => (
                      <Grow {...TransitionProps}>
                        {/* <Paper> */}
                        <Paper
                          elevation={8}
                          sx={{
                            backgroundColor: "#fff",
                            backgroundImage: "none",
                            opacity: 1,
                            border: "1px solid #ddd",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                          }}
                        >
                          <ClickAwayListener onClickAway={() => handleClickAway(setServicesOpen)}>
                            <MenuList onMouseEnter={() => setServicesOpen(true)} onMouseLeave={handleServicesMouseLeave}>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.cityToCityRides)}> {t("header-ourservices-CityToCityRides") || "City To City Rides"}</MenuItem>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.airportTransfer)}>{t("header-ourservices-airportTransfer") || "Airport Transfer"}</MenuItem>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.businessTransfer)}>{t("header-ourservices-BusinessTransfer") || "Business Transfer"}</MenuItem>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.tourAndEventTransfer)}>{t("header-ourservices-TourAndEventTransfer") || "Tour And Event Transfer"}</MenuItem> 
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.baggageTransfer)}>{t("header-ourservices-BaggageTransfer") || "Baggage Transfer Service"}</MenuItem>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.petTransfer)}>{t("header-ourservices-PetTransfer") || "Pet Transfer Service"}</MenuItem>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.patientTransfer)}>{t("header-ourservices-PatientTransfer") || "Patient Transfer Service"}</MenuItem>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.vipService)}>{t("header-ourservices-VipService") || "Vip Service"}</MenuItem>
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </NavItem>

                
                {/* Help Dropdown */}
                {/* <NavItem
                  onMouseEnter={handleHelpMouseEnter}
                  onMouseLeave={handleHelpMouseLeave}
                  style={{ position: "relative" }}
                >
                  <NavLink style={{ cursor: "pointer", color: "#000", ...avenirNextStyle }}>
                   {t("header-help") || "Help Center"}
                    <KeyboardArrowDownIcon
                      fontSize="small"
                      style={{
                        marginLeft: "4px",
                        transition: "0.3s",
                        transform: helpOpen ? "rotate(180deg)" : "rotate(0deg)",
                        color: "#000",
                      }}
                    />
                  </NavLink>
                  <Popper open={helpOpen} anchorEl={helpAnchor} placement="bottom-start" transition disablePortal>
                    {({ TransitionProps }) => (
                      <Grow {...TransitionProps}>
                        <Paper>
                          <ClickAwayListener onClickAway={() => handleClickAway(setHelpOpen)}>
                            <MenuList onMouseEnter={() => setHelpOpen(true)} onMouseLeave={handleHelpMouseLeave}>
                              <MenuItem style={avenirNextStyle} onClick={() => navigate(paths.qans)}>FAQ</MenuItem>
                              <MenuItem style={avenirNextStyle} onClick={handleHelpMouseLeave}>Support</MenuItem>
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </NavItem> */}
                <NavItem>
                  <NavLink>
                    <Link to={paths.qans} className="nav-link text-dark" style={avenirNextStyle}>
                      {"FAQ's"}
                    </Link>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink>
                    <Link to={paths.contactUs} className="nav-link text-dark" style={avenirNextStyle}>
                      {t("header-ContactUs") || "Contact Us"}
                    </Link>
                  </NavLink>
                </NavItem>

              </Nav>

              {/* Right side buttons */}
<div className="d-flex flex-column flex-md-row align-items-center gap-3 gap-md-4">                
  {!logingUser?.token && (
                  <>
                    <Link to={paths.accounts.login}>
                      <Button
                        style={{
                          // borderRadius: "4px",
                          // padding: "0.5rem 1.2rem",
                          fontWeight: 400,
                          textTransform: "none",
                          fontSize: "16px",
                          color: "#000",
                          // border: "1px solid #000",
                          backgroundColor: "#fff",
                          ...avenirNextStyle
                        }}
                      >
                        Sign In
                      </Button>
                    </Link>

                    {/* Register dropdown */}
                    <div
                      onMouseEnter={handleRegisterMouseEnter}
                      onMouseLeave={handleRegisterMouseLeave}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      <div style={{ display: "flex", alignItems: "center", color: "#ffffff", ...avenirNextStyle,border: "1px solid #000",borderRadius: "20px", padding: "0.5rem 1.2rem", backgroundColor:"#0b2d48"}}>
                        Register
                        <KeyboardArrowDownIcon
                          fontSize="small"
                          style={{
                            marginLeft: "4px",
                            transition: "0.3s",
                            transform: registerOpen ? "rotate(180deg)" : "rotate(0deg)",
                          }}
                        />
                      </div>
<Popper
  open={registerOpen}
  anchorEl={registerAnchor}
  placement="bottom-start"
  transition
  disablePortal
  modifiers={[
    {
      name: "offset",
      options: {
        offset: [0, 12], // [horizontal, vertical] → increase vertical to move down
      },
    },
  ]}
>
                        {({ TransitionProps }) => (
                          <Grow {...TransitionProps}>
                            <Paper>
                              <ClickAwayListener onClickAway={() => handleClickAway(setRegisterOpen)}>
                                <MenuList
                                  onMouseEnter={() => setRegisterOpen(true)}
                                  onMouseLeave={handleRegisterMouseLeave}
                                >
                                  <MenuItem onClick={() => navigate(paths.accounts.socialLogin)} style={avenirNextStyle} >User Registration</MenuItem>
                                  <MenuItem onClick={() => navigate(paths.accounts.driverCarrierRegister)} style={avenirNextStyle} >Carrier Registration</MenuItem>
                                  <MenuItem onClick={() => navigate(paths.accounts.agentRegister)} style={avenirNextStyle} >Company/Agent Registration</MenuItem>
                                </MenuList>
                              </ClickAwayListener>
                            </Paper>
                          </Grow>
                        )}
                      </Popper>
                    </div>
                  </>
                )}

               {logingUser?.token && logingUser?.user?.data?.role === "1" && (
 <NavItem className="list-unstyled">
  <NavLink
    tag={Link}
    to={paths.user.dashboard}
    className="nav-link text-dark d-flex align-items-center gap-2"
    style={avenirNextStyle}
  >
    <FaUserCircle size={28} color="#000" />
    {logingUser?.user?.data?.username}
  </NavLink>
</NavItem>

)}


                
              </div>
            </Collapse>
          </Navbar>
        </header>


      </div>
    </>
  );
}
